import React, { Component } from 'react'
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import './yearpicker.css'
import {MuiPickersUtilsProvider,KeyboardDatePicker,DateTimePicker, KeyboardTimePicker} from '@material-ui/pickers';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import { IconButton } from "@material-ui/core";
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import moment from "moment";
import { withStyles } from "@material-ui/core/styles";

import { Modal } from 'react-bootstrap';
var DefaultDate = new Date()
export class DatePicker extends Component {
    constructor(props){
        super(props)
        this.handleDateChange = this.handleDateChange.bind(this)
    }
    handleDateChange(newDate){
        DefaultDate = newDate
        var date = moment(newDate).format('YYYY-MM-DD HH:mm:ss');
        this.props.onChange(date)
    }
    render() {
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                    // inputFormat="yyyy-MM"
                    
                    views={this.props.views}
                    label={this.props.label}
                    variant="static"
                    value={this.props.defaults != undefined ? new Date(this.props.defaults) : DefaultDate}
                    onChange={(e) => this.handleDateChange(e)}
                    disablePast={this.props.disablePast}
                    disableFuture={this.props.disableFuture}
                    disableToolbar={this.props.disableToolbar}
                    animateYearScrolling={true}
                />
            </MuiPickersUtilsProvider>
        )
    }
}
export class Datetimepicker extends Component {
    constructor(props) {
      super(props);
      this.state = {
        selectedDate: props.defaults !==undefined ? props.defaults : null,
        openDialog: true, 
      };
      this.handleDateChange = this.handleDateChange.bind(this);
    }
  
    handleDateChange(newDate) {
      this.setState({ selectedDate: newDate });
      const formattedDate = moment(newDate).format('YYYY-MM-DD HH:mm:ss');
      this.props.onChange(formattedDate);
      this.props.onHide()
    }
  
    render() {
      console.log(this.props.defaults,"defaults")
      console.log(this.state.selectedDate,"state")
      const { selectedDate, openDialog } = this.state;
      const { disablePast, disableFuture, disableToolbar } = this.props;
  
      return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <DateTimePicker
            variant="dialog"  
            value={selectedDate}
            onChange={this.handleDateChange}
            disablePast={disablePast}
            disableFuture={disableFuture}
            disableToolbar={disableToolbar}
            open={openDialog}  
            onClose={() =>{
                
                this.setState({ openDialog: false })
                this.props.onHide()
            } } 
            animateYearScrolling={true}
          />
        </MuiPickersUtilsProvider>
      );
    }
  }


export class TimePicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTime: new Date(), 
        };
    }

    componentDidMount() {
        if (this.props.defaults) {
            const defaultTime = new Date(this.props.defaults);
            if (!isNaN(defaultTime)) {
                this.setState({ selectedTime: defaultTime });
            }
        }
    }

    handleOk = () => {
        const { selectedTime } = this.state;

        if (selectedTime && !isNaN(selectedTime)) {
            const formattedTime = moment(selectedTime).format("YYYY-MM-DD HH:mm:ss");
            this.props.onChange(formattedTime);
        } else {
            console.error("Invalid selectedTime:", selectedTime);
        }
    };

    render() {
        return (
            <Modal
                id="dateModal"
                centered
                style={{ backgroundColor: "rgba(0,0,0,0.6)" }}
                show={this.props.openTimePicker}
                onHide={() => this.props.onHideTimePicker(false)}
            >
                <Modal.Body>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardTimePicker
                            variant="static"
                            value={this.state.selectedTime} 
                            onChange={(date) => {
                                if (date && !isNaN(date)) {
                                    this.setState({ selectedTime: date });
                                }
                            }}
                        />
                    </MuiPickersUtilsProvider>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            width: "100%",
                            minHeight: "50px",
                        }}
                    >
                        <span
                            className="modalbutton"
                            onClick={() => this.props.onHideTimePicker(false)}
                        >
                            Cancel
                        </span>
                        <span className="modalbutton" onClick={this.handleOk}>
                            Ok
                        </span>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}




const styles = {
  header: {
    backgroundColor: "#29b6f6",
    color: "white",
    height: "10vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    fontWeight: 600,
    fontSize: "18px",
    padding: "0 12px",
  },
  

  pickerRoot: {
      backgroundColor: "#f0f4f8",
    borderRadius: 8,
    padding: 16,
    "& .MuiPickersBasePicker-containerLandscape": {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center"
    }
  },
  monthButton: {
    width: 50,
    height: 50,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50% !important",
    margin: 4,
    cursor: "pointer",
    "&.MuiPickersMonth-root": {
      backgroundColor: "#e3f2fd",
      transition: "all 0.3s",
    },
    "&.Mui-selected": {
      backgroundColor: "#03a9f4",
      color: "white",
      fontWeight: "bold",
      border: "2px solid #29b6f6",  
      transform: "scale(1.1)",
    },
    "&:hover": {
      backgroundColor: "#81d4fa",
      transform: "scale(1.05)",
    },
  },
};


class MonthYearPickers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentDate: this.props.defaultsdate ? new Date(this.props.defaultsdate) : new Date(),
    };
  }

  componentDidMount(){
    console.log(this.props.defaults,"props.defaults")
  }

  componentDidUpdate(prevProps) {
  if (prevProps.defaultsdate !== this.props.defaultsdate) {
    this.setState({ currentDate: new Date(this.props.defaultsdate) });
  }
}

  handleDateChange = (newDate) => {
    const date = moment(newDate).format("YYYY-MM-DD");
    this.setState({ currentDate: newDate });
    this.props.onChange(date);
  };

  changeYear = (direction) => {
    const { currentDate } = this.state;
    const newDate =
      direction === "prev"
        ? new Date(currentDate.setFullYear(currentDate.getFullYear() - 1))
        : new Date(currentDate.setFullYear(currentDate.getFullYear() + 1));

        
    this.handleDateChange(newDate);
  };

  render() {
    const { currentDate } = this.state;
    const { classes } = this.props;

    return (
      <div style={{ position: "relative" }} className='monthpikerali' >
        <div className={classes.header}>
          <IconButton onClick={() => this.changeYear("prev")} size="small" style={{ color: "white" }}>
            <KeyboardDoubleArrowLeftIcon />
          </IconButton>

          <div>{moment(currentDate).format("MMMM YYYY")}</div>

          <IconButton onClick={() => this.changeYear("next")} size="small" style={{ color: "white" }}>
            <KeyboardDoubleArrowRightIcon />
          </IconButton>
        </div>

       
        <MuiPickersUtilsProvider utils={DateFnsUtils}  sx={{
    "& .MuiPickersLayout-root": {
      flexDirection: "row",
      justifyContent: "center"
    }
  }}>
    <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  > <KeyboardDatePicker
            variant="static"
            value={currentDate}
            onChange={this.handleDateChange}
            views={["month"]}
            inputFormat="MMMM"
            disableToolbar
            className={classes.pickerRoot}
            classes={{ month: classes.monthButton }}
          /></div>
         
        </MuiPickersUtilsProvider>
      </div>
    );
  }
}

export default withStyles(styles)(MonthYearPickers);
